import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/pdf.svg'
import _imports_3 from '@/assets/doc.svg'
import _imports_4 from '@/assets/docx.svg'
import _imports_5 from '@/assets/xls.svg'
import _imports_6 from '@/assets/xlsx.svg'
import _imports_7 from '@/assets/txt.svg'
import _imports_8 from '@/assets/png.svg'
import _imports_9 from '@/assets/jpg.svg'
import _imports_10 from '@/assets/jpeg.svg'
import _imports_11 from '@/assets/csv.svg'
import _imports_12 from '@/assets/zip.svg'
import _imports_13 from '@/assets/mp4.svg'
import _imports_14 from '@/assets/deleteIcon.svg'
import _imports_15 from '@/assets/sortBy.svg'
import _imports_16 from '@/assets/arrowRight.svg'
import _imports_17 from '@/assets/cancel.svg'
import _imports_18 from '@/assets/fileUploadIcon.svg'
import _imports_19 from '@/assets/Browse.svg'
import _imports_20 from '@/assets/warning.svg'


const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = {
  key: 1,
  class: "row w-full h-full flex mt-2"
}
const _hoisted_3 = { class: "w-2/5" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "flex w-3/5 justify-between" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "w-full minheight" }
const _hoisted_9 = { class: "w-full" }
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = { class: "mainContainer tabStructure w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey flex" }
const _hoisted_12 = { class: "w-80 pr-5" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_15 = {
  key: 1,
  class: "h-full"
}
const _hoisted_16 = {
  key: 0,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_17 = { class: "pt-3 flex" }
const _hoisted_18 = { class: "w-6/12" }
const _hoisted_19 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_20 = {
  key: 1,
  class: "mt-1 mb-4"
}
const _hoisted_21 = { class: "w-6/12" }
const _hoisted_22 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_23 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = { class: "w-6/12" }
const _hoisted_26 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_27 = {
  key: 1,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_28 = { class: "w-6/12" }
const _hoisted_29 = { class: "mt-1 mb-3 text-sm" }
const _hoisted_30 = { class: "flex" }
const _hoisted_31 = { class: "w-6/12" }
const _hoisted_32 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_33 = {
  key: 1,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_34 = { class: "w-6/12" }
const _hoisted_35 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_36 = {
  key: 1,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_37 = { class: "w-full" }
const _hoisted_38 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_39 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_40 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_41 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_42 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_43 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_44 = {
  key: 1,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_45 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_46 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_47 = { class: "flex flex-row" }
const _hoisted_48 = { class: "text-xs py-0.5 font-opensans bg-white font-bold h-auto flex items-center my-1.5 header" }
const _hoisted_49 = { class: "flex items-center" }
const _hoisted_50 = { class: "flex flex-row w-50 mt-2 mb-2" }
const _hoisted_51 = { class: "w-50 border-t border-r border-b p-2 header border-lightgrey rounded-r-sm" }
const _hoisted_52 = { class: "pl-3 flex items-center flex-wrap" }
const _hoisted_53 = { class: "flex" }
const _hoisted_54 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_55 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_56 = {
  key: 1,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_57 = {
  key: 2,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_58 = { class: "border-b border-lightgrey flex justify-between pb-2 mt-3" }
const _hoisted_59 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_60 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_61 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_62 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_63 = {
  key: 3,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_64 = { class: "evidence-tab-content" }
const _hoisted_65 = { class: "evidence-files-block" }
const _hoisted_66 = { class: "border-b border-lightgrey flex justify-between items-center pb-2 mt-3" }
const _hoisted_67 = { class: "buttonposition flex justify-center items-center gap-2" }
const _hoisted_68 = {
  key: 0,
  class: "flex mt-5 gap-4 flex-wrap"
}
const _hoisted_69 = { class: "pdf w-full rounded-sm" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = {
  key: 0,
  src: _imports_2,
  alt: ""
}
const _hoisted_72 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
const _hoisted_73 = {
  key: 2,
  src: _imports_4,
  alt: ""
}
const _hoisted_74 = {
  key: 3,
  src: _imports_5,
  alt: ""
}
const _hoisted_75 = {
  key: 4,
  src: _imports_6,
  alt: ""
}
const _hoisted_76 = {
  key: 5,
  src: _imports_2,
  alt: ""
}
const _hoisted_77 = {
  key: 6,
  src: _imports_7,
  alt: ""
}
const _hoisted_78 = {
  key: 7,
  src: _imports_8,
  alt: ""
}
const _hoisted_79 = {
  key: 8,
  src: _imports_9,
  alt: ""
}
const _hoisted_80 = {
  key: 9,
  src: _imports_10,
  alt: ""
}
const _hoisted_81 = {
  key: 10,
  src: _imports_11,
  alt: ""
}
const _hoisted_82 = {
  key: 11,
  src: _imports_12,
  alt: ""
}
const _hoisted_83 = {
  key: 12,
  src: _imports_13,
  alt: ""
}
const _hoisted_84 = { class: "flex flex-col w-full min-w-0" }
const _hoisted_85 = { class: "ml-2 pb-1" }
const _hoisted_86 = ["title"]
const _hoisted_87 = { class: "flex justify-between w-full" }
const _hoisted_88 = { class: "ml-2 fontSize10PX" }
const _hoisted_89 = { class: "mr-2 fontSize10PX font-semibold" }
const _hoisted_90 = ["onClick"]
const _hoisted_91 = {
  key: 1,
  class: "text-xs text-placeholdergray mt-3"
}
const _hoisted_92 = { class: "evidence-links-section" }
const _hoisted_93 = { class: "border-b border-lightgrey flex justify-between items-center pb-2 mt-6" }
const _hoisted_94 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_95 = { class: "evidence-links-scroll" }
const _hoisted_96 = { class: "evidence-links-header" }
const _hoisted_97 = { class: "flex items-center" }
const _hoisted_98 = { class: "flex items-center" }
const _hoisted_99 = { class: "flex items-center" }
const _hoisted_100 = { class: "flex items-center" }
const _hoisted_101 = { class: "evidence-links-body" }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = ["title"]
const _hoisted_104 = { class: "table-ellipsis" }
const _hoisted_105 = ["title"]
const _hoisted_106 = { class: "table-ellipsis" }
const _hoisted_107 = { class: "evidence-links-col-link" }
const _hoisted_108 = { class: "table-ellipsis" }
const _hoisted_109 = ["onClick", "title"]
const _hoisted_110 = { class: "evidence-links-col-date" }
const _hoisted_111 = { class: "evidence-links-col-action" }
const _hoisted_112 = ["onClick"]
const _hoisted_113 = { key: 1 }
const _hoisted_114 = {
  key: 4,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_115 = { class: "border-b border-lightgrey flex justify-between pb-2 mt-3" }
const _hoisted_116 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_117 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_118 = { class: "comment-box w-full mt-5" }
const _hoisted_119 = {
  key: 0,
  class: "comments"
}
const _hoisted_120 = { class: "initials" }
const _hoisted_121 = { class: "w-1/5" }
const _hoisted_122 = { class: "header" }
const _hoisted_123 = { class: "fontSize10PX" }
const _hoisted_124 = { class: "w-4/5 text-xs text-justify" }
const _hoisted_125 = {
  key: 5,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_126 = { class: "border-b border-lightgrey flex justify-between pb-2 mt-3" }
const _hoisted_127 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_128 = {
  key: 0,
  class: ""
}
const _hoisted_129 = ["onClick"]
const _hoisted_130 = ["onClick"]
const _hoisted_131 = { class: "flex flex-row" }
const _hoisted_132 = { class: "border header border-lightgrey w-77 p-2 rounded-tr-md" }
const _hoisted_133 = { class: "w-full flex flex-row" }
const _hoisted_134 = { class: "w-27 border-b border-l border-lightgrey text-xs p-2" }
const _hoisted_135 = { class: "mt-1" }
const _hoisted_136 = { class: "border-r w-27 border-b border-l border-lightgrey p-2" }
const _hoisted_137 = { class: "pl-3 flex items-center flex-wrap" }
const _hoisted_138 = { class: "flex flex-row" }
const _hoisted_139 = { class: "border-r border-b border-l border-lightgrey w-77 text-xs p-2" }
const _hoisted_140 = { class: "flex flex-row" }
const _hoisted_141 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-xs" }
const _hoisted_142 = { class: "flex flex-row" }
const _hoisted_143 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-xs flex items-center" }
const _hoisted_144 = ["title"]
const _hoisted_145 = { key: 1 }
const _hoisted_146 = { class: "flex flex-row" }
const _hoisted_147 = { class: "flex border-r border-b border-l border-lightgrey w-77 p-2" }
const _hoisted_148 = {
  key: 0,
  class: "ml-0.5 text-xs"
}
const _hoisted_149 = { key: 0 }
const _hoisted_150 = {
  key: 1,
  class: "border-r border-b border-l border-lightgrey"
}
const _hoisted_151 = { class: "w-full flex flex-row" }
const _hoisted_152 = { class: "w-27 border-b border-l border-lightgrey p-2" }
const _hoisted_153 = {
  key: 0,
  class: "flex items-center justify-center rounded w-28 h-5 text-error bg-highColor border-solid border text-xs border-error p-1 font-semibold"
}
const _hoisted_154 = {
  key: 1,
  class: "flex items-center justify-center rounded w-28 h-5 text-darkred bg-veryHighColor border-solid border text-xs border-darkred p-1 font-semibold"
}
const _hoisted_155 = {
  key: 2,
  class: "flex items-center justify-center rounded w-28 h-5 text-lightgreen bg-veryLowColor border-solid border text-xs border-lightgreen p-1 font-semibold"
}
const _hoisted_156 = {
  key: 3,
  class: "flex items-center justify-center rounded w-28 h-5 text-yellow bg-moderateColor border-solid border text-xs border-yellow p-1 font-semibold"
}
const _hoisted_157 = {
  key: 4,
  class: "text-xs"
}
const _hoisted_158 = { class: "border-r w-27 border-b border-l border-lightgrey p-2 rounded-br-md" }
const _hoisted_159 = {
  key: 0,
  class: "flex items-center justify-center rounded h-5 w-28 text-lightgreen bg-veryLowColor text-xs border-solid border border-lightgreen font-semibold"
}
const _hoisted_160 = {
  key: 1,
  class: "flex items-center justify-center rounded h-5 w-28 text-darkred bg-veryHighColor text-xs border-solid border border-darkred font-semibold"
}
const _hoisted_161 = {
  key: 2,
  class: "text-xs"
}
const _hoisted_162 = {
  key: 6,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_163 = { class: "border-b border-lightgrey flex justify-between pb-2 mt-3" }
const _hoisted_164 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_165 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_166 = { class: "flex" }
const _hoisted_167 = {
  key: 0,
  class: "initials"
}
const _hoisted_168 = {
  key: 1,
  class: "initials"
}
const _hoisted_169 = { class: "logContainer w-93" }
const _hoisted_170 = { class: "flex mt-1" }
const _hoisted_171 = {
  key: 0,
  class: "font-semibold text-xs"
}
const _hoisted_172 = {
  key: 1,
  class: "font-semibold text-xs"
}
const _hoisted_173 = {
  key: 2,
  class: "mx-2 text-xs"
}
const _hoisted_174 = {
  key: 3,
  class: "mx-2 text-xs"
}
const _hoisted_175 = {
  key: 4,
  class: "mx-2 text-xs"
}
const _hoisted_176 = {
  key: 5,
  class: "mx-2 text-xs"
}
const _hoisted_177 = {
  key: 6,
  class: "font-semibold text-xs"
}
const _hoisted_178 = {
  key: 7,
  class: "font-semibold text-xs"
}
const _hoisted_179 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_180 = {
  key: 0,
  class: "flex"
}
const _hoisted_181 = { class: "text-xs w-full text-justify" }
const _hoisted_182 = {
  key: 1,
  class: "flex"
}
const _hoisted_183 = { class: "mx-2 text-xs" }
const _hoisted_184 = {
  key: 2,
  class: "flex"
}
const _hoisted_185 = { class: "mx-2 text-xs" }
const _hoisted_186 = {
  key: 3,
  class: "flex"
}
const _hoisted_187 = { class: "mx-2 text-xs" }
const _hoisted_188 = { class: "mx-2 text-xs" }
const _hoisted_189 = { class: "mx-2 text-xs" }
const _hoisted_190 = { class: "font-semibold text-xs shrink-0 whitespace-nowrap" }
const _hoisted_191 = ["title"]
const _hoisted_192 = ["title"]
const _hoisted_193 = { class: "mx-2 text-xs" }
const _hoisted_194 = { class: "text-xs" }
const _hoisted_195 = {
  key: 4,
  class: "flex"
}
const _hoisted_196 = { class: "mx-2 text-xs" }
const _hoisted_197 = {
  key: 5,
  class: "flex"
}
const _hoisted_198 = { class: "mx-2 text-xs" }
const _hoisted_199 = {
  key: 6,
  class: "flex"
}
const _hoisted_200 = { class: "mx-2 text-xs" }
const _hoisted_201 = {
  key: 7,
  class: "flex mt-2"
}
const _hoisted_202 = { class: "mx-2 text-xs" }
const _hoisted_203 = {
  key: 8,
  class: "flex mt-2"
}
const _hoisted_204 = { class: "mx-2 text-xs" }
const _hoisted_205 = {
  key: 9,
  class: "flex mt-2"
}
const _hoisted_206 = { class: "mx-2 text-xs" }
const _hoisted_207 = {
  key: 10,
  class: "flex mt-2"
}
const _hoisted_208 = { class: "mx-2 text-xs" }
const _hoisted_209 = { class: "mx-2 text-xs" }
const _hoisted_210 = {
  key: 11,
  class: "flex"
}
const _hoisted_211 = { class: "mx-2 text-xs" }
const _hoisted_212 = {
  key: 12,
  class: "flex items-center"
}
const _hoisted_213 = { class: "flex ml-4" }
const _hoisted_214 = { class: "w-20 border taskDetailsRightBar rounded-sm border-lightgrey" }
const _hoisted_215 = { class: "m-3" }
const _hoisted_216 = { key: 0 }
const _hoisted_217 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_218 = {
  key: 1,
  class: "pt-1.5 overflow-y-scroll thirtyWidthToggle"
}
const _hoisted_219 = { class: "flex flex-col mb-3" }
const _hoisted_220 = {
  key: 0,
  disabled: "",
  type: "text",
  placeholder: "Status",
  class: "terminateBox inputboxstyling mt-2",
  value: "Terminated"
}
const _hoisted_221 = {
  key: 1,
  disabled: "",
  type: "text",
  placeholder: "Status",
  class: "completedBox inputboxstyling mt-2",
  value: "Completed"
}
const _hoisted_222 = {
  key: 2,
  disabled: "",
  type: "text",
  placeholder: "Status",
  class: "bg-darkred textColorWhite inputboxstyling mt-2",
  value: "Not Applicable"
}
const _hoisted_223 = { key: 3 }
const _hoisted_224 = {
  key: 0,
  class: "mt-2 mb-3"
}
const _hoisted_225 = { key: 1 }
const _hoisted_226 = { class: "mt-3" }
const _hoisted_227 = ["disabled"]
const _hoisted_228 = { class: "mt-3" }
const _hoisted_229 = {
  key: 0,
  class: "my-1 mt-2 text-sm"
}
const _hoisted_230 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_231 = { class: "mt-3" }
const _hoisted_232 = {
  key: 0,
  class: "my-1 mt-2 text-sm"
}
const _hoisted_233 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_234 = { class: "mt-3" }
const _hoisted_235 = {
  key: 0,
  class: "my-1 mt-2 text-sm"
}
const _hoisted_236 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_237 = { class: "mt-3" }
const _hoisted_238 = {
  key: 0,
  class: "my-1 mt-2 text-sm"
}
const _hoisted_239 = {
  key: 1,
  class: "my-1 mt-2 text-sm"
}
const _hoisted_240 = { class: "mt-3" }
const _hoisted_241 = { class: "my-1 mt-2 text-sm" }
const _hoisted_242 = { class: "mt-3" }
const _hoisted_243 = { class: "my-1 mt-2 text-sm" }
const _hoisted_244 = { class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex" }
const _hoisted_245 = { class: "relative w-full max-w-xl" }
const _hoisted_246 = { class: "border-0 rounded relative flex flex-col w-full bg-white h-screen" }
const _hoisted_247 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_248 = { class: "flex-1 overflow-auto" }
const _hoisted_249 = { class: "impactcontainer popupbodycontainer" }
const _hoisted_250 = { class: "formcontainer flex flex-col" }
const _hoisted_251 = { class: "row flex flex-col mt-2" }
const _hoisted_252 = { class: "controllabel" }
const _hoisted_253 = ["placeholder"]
const _hoisted_254 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_255 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_256 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_257 = {
  key: 0,
  class: "pt-3"
}
const _hoisted_258 = {
  key: 0,
  class: "text-sm font-semibold text-darkblue mb-4"
}
const _hoisted_259 = {
  key: 1,
  class: "text-sm font-semibold text-primary mb-4"
}
const _hoisted_260 = { class: "flex items-center justify-center gap-2" }
const _hoisted_261 = ["disabled"]
const _hoisted_262 = { class: "min-h-[22px] text-red-500" }
const _hoisted_263 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_264 = {
  key: 1,
  class: "text-red-500 text-xs"
}
const _hoisted_265 = {
  key: 1,
  class: "pt-3"
}
const _hoisted_266 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_267 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_268 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_269 = { class: "pt-3 w-1/2" }
const _hoisted_270 = ["max"]
const _hoisted_271 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_272 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_273 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_274 = ["disabled"]
const _hoisted_275 = { class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex" }
const _hoisted_276 = { class: "relative w-full max-w-xl" }
const _hoisted_277 = { class: "border-0 rounded relative flex flex-col w-full bg-white h-screen" }
const _hoisted_278 = { class: "flex items-center justify-between m-4 rounded" }
const _hoisted_279 = { class: "flex-1 overflow-auto" }
const _hoisted_280 = { class: "impactcontainer popupbodycontainer" }
const _hoisted_281 = { class: "statuscontainer" }
const _hoisted_282 = { class: "formcontainer flex flex-col" }
const _hoisted_283 = { class: "row flex flex-row w-full mt-3 mb-3" }
const _hoisted_284 = { class: "w-1/2 pr-2" }
const _hoisted_285 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_286 = {
  key: 0,
  class: "error-text"
}
const _hoisted_287 = { class: "w-1/2 pl-2" }
const _hoisted_288 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_289 = {
  key: 0,
  class: "error-text"
}
const _hoisted_290 = { class: "row flex flex-row w-full mb-3" }
const _hoisted_291 = { class: "w-1/2 pr-2" }
const _hoisted_292 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_293 = {
  key: 0,
  class: "error-text"
}
const _hoisted_294 = { class: "w-1/2 pl-2" }
const _hoisted_295 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_296 = {
  key: 0,
  class: "error-text"
}
const _hoisted_297 = { class: "w-full mb-3" }
const _hoisted_298 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_299 = {
  key: 0,
  class: "error-text"
}
const _hoisted_300 = { class: "row flex flex-row w-full mb-3" }
const _hoisted_301 = { class: "w-1/2 pr-2" }
const _hoisted_302 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_303 = {
  key: 0,
  class: "error-text"
}
const _hoisted_304 = { class: "w-full mb-3" }
const _hoisted_305 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_306 = {
  key: 0,
  class: "error-text"
}
const _hoisted_307 = { class: "w-full mb-3" }
const _hoisted_308 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_309 = {
  key: 0,
  class: "error-text"
}
const _hoisted_310 = { class: "w-1/2 mt-3 mb-3" }
const _hoisted_311 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_312 = ["disabled"]
const _hoisted_313 = ["disabled"]
const _hoisted_314 = {
  key: 4,
  class: "completeFindingsDialog fixed inset-0 flex items-center justify-center"
}
const _hoisted_315 = { class: "completeFindingsCard relative bg-white rounded-md shadow-lg" }
const _hoisted_316 = { class: "completeFindingsActions flex justify-end" }
const _hoisted_317 = {
  key: 5,
  class: "completeFindingsDialog fixed inset-0 flex items-center justify-center"
}
const _hoisted_318 = { class: "completeFindingsCard relative bg-white rounded-md shadow-lg" }
const _hoisted_319 = { class: "flex items-start" }
const _hoisted_320 = { class: "text-sm text-gray mt-2" }
const _hoisted_321 = { class: "completeFindingsActions flex justify-end" }
const _hoisted_322 = {
  key: 6,
  class: "evidence-delete-confirm"
}
const _hoisted_323 = { class: "evidence-delete-dialog" }
const _hoisted_324 = { class: "evidence-delete-dialog-actions" }
const _hoisted_325 = {
  key: 7,
  class: "link-existing-confirm"
}
const _hoisted_326 = { class: "link-existing-dialog" }
const _hoisted_327 = { class: "link-existing-tables" }
const _hoisted_328 = { class: "link-existing-section-row" }
const _hoisted_329 = { class: "link-existing-section" }
const _hoisted_330 = { class: "link-existing-table" }
const _hoisted_331 = { class: "flex table-header-label-wrap" }
const _hoisted_332 = { class: "flex table-header-label-wrap" }
const _hoisted_333 = { class: "flex table-header-label-wrap" }
const _hoisted_334 = { class: "flex table-header-label-wrap" }
const _hoisted_335 = {
  key: 0,
  class: "link-existing-filter-row"
}
const _hoisted_336 = { key: 0 }
const _hoisted_337 = { class: "link-existing-col-check" }
const _hoisted_338 = ["checked", "onChange"]
const _hoisted_339 = ["title"]
const _hoisted_340 = { key: 1 }
const _hoisted_341 = { class: "link-existing-actions" }
const _hoisted_342 = { key: 8 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_tableData = _resolveComponent("tableData")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_commentsEditor = _resolveComponent("commentsEditor")!
  const _component_safeHtml = _resolveComponent("safeHtml")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_tool_tip = _resolveComponent("tool-tip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.modalMode ? 'details-in-modal task-details-in-modal' : 'mb-5 mx-5 mt-3 ResponsiveControlePage')
  }, [
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.presentTaskObject.controlTitle), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_6, [
                _cache[71] || (_cache[71] = _createTextVNode(" Audit Id : ")),
                _createElementVNode("b", null, _toDisplayString(_ctx.presentAuditObject.auditId), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_7, [
                _cache[72] || (_cache[72] = _createTextVNode(" Audit Title : ")),
                _createElementVNode("b", null, _toDisplayString(_ctx.presentAuditObject.title), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Tabs, {
                value: _ctx.selectedTabIndex,
                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
                scrollable: "",
                class: "heightFixing"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_TabList, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                          return (_openBlock(), _createBlock(_component_Tab, {
                            key: tab.id,
                            value: tab.id,
                            onClick: ($event: any) => (_ctx.toggleTabs(tab))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tab.displayName), 1)
                            ]),
                            _: 2
                          }, 1032, ["value", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_TabPanels, { class: "overflow-auto hide-scrollbar" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                        return (_openBlock(), _createBlock(_component_TabPanel, {
                          key: tab.id,
                          value: tab.id
                        }, {
                          default: _withCtx(() => [
                            (_ctx.tabDataLoading == true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_dots_loader)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  (tab.id == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _createElementVNode("div", _hoisted_17, [
                                          _createElementVNode("div", _hoisted_18, [
                                            _cache[73] || (_cache[73] = _createElementVNode("div", null, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", { class: "font-extrabold mb-1 text-xs" }, [
                                                  _createElementVNode("p", null, "CID")
                                                ])
                                              ])
                                            ], -1)),
                                            (_ctx.presentTaskObject.clientUniqueId)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.presentTaskObject.clientUniqueId != undefined || _ctx.presentTaskObject.clientUniqueId == '' ? _ctx.presentTaskObject.clientUniqueId : 'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_20, "-"))
                                          ]),
                                          _createElementVNode("div", _hoisted_21, [
                                            _cache[74] || (_cache[74] = _createElementVNode("p", { class: "font-extrabold text-xs" }, "Frequency", -1)),
                                            ((_ctx.presentTaskObject.controlFrequency))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.dbFrequency.find((l) => l.value == _ctx.presentTaskObject.controlFrequency)?.key||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_23, "N/A"))
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_24, [
                                          _createElementVNode("div", _hoisted_25, [
                                            _cache[75] || (_cache[75] = _createElementVNode("div", null, [
                                              _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Title")
                                            ], -1)),
                                            (_ctx.presentTaskObject.controlTitle !=undefined && _ctx.presentTaskObject.controlTitle != '')
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.presentTaskObject.controlTitle), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString('N/A')))
                                          ]),
                                          _createElementVNode("div", _hoisted_28, [
                                            _cache[76] || (_cache[76] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Type", -1)),
                                            _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.presentTaskObject?.controlType||'N/A'), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_30, [
                                          _createElementVNode("div", _hoisted_31, [
                                            _cache[77] || (_cache[77] = _createElementVNode("div", null, [
                                              _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Class")
                                            ], -1)),
                                            (_ctx.presentTaskObject.controlClass !=undefined && _ctx.presentTaskObject.controlClass != '')
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_ctx.presentTaskObject.controlClass), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString('N/A')))
                                          ]),
                                          _createElementVNode("div", _hoisted_34, [
                                            _cache[78] || (_cache[78] = _createElementVNode("div", null, [
                                              _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Family")
                                            ], -1)),
                                            (_ctx.presentTaskObject.controlFamily !=undefined && _ctx.presentTaskObject.controlFamily != '')
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.presentTaskObject.controlFamily), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString('N/A')))
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_37, [
                                          _cache[79] || (_cache[79] = _createElementVNode("p", { class: "font-extrabold text-xs" }, "Priority", -1)),
                                          (_ctx.presentTaskObject?.controlPriority && typeof _ctx.presentTaskObject?.controlPriority === 'number')
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2 mb-3", _ctx.colorLabelBg(_ctx.presentTaskObject?.controlPriority)])
                                              }, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.presentTaskObject?.controlPriority)])
                                                }, _toDisplayString(_ctx.getProirityLabel(_ctx.presentTaskObject?.controlPriority)), 3)
                                              ], 2))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_38, "N/A"))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[80] || (_cache[80] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Description", -1)),
                                          ((_ctx.presentTaskObject?.Description))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(_ctx.presentTaskObject?.Description||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_40, "N/A"))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[81] || (_cache[81] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Policy/Procedure", -1)),
                                          ((_ctx.presentTaskObject?.controlPolicies))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(_ctx.presentTaskObject?.controlPolicies||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_42, "N/A"))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[82] || (_cache[82] = _createElementVNode("div", null, [
                                            _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Guidance")
                                          ], -1)),
                                          (_ctx.presentTaskObject.controlGuidance !=undefined && _ctx.presentTaskObject.controlGuidance != '')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(_ctx.presentTaskObject.controlGuidance), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString('N/A')))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[83] || (_cache[83] = _createElementVNode("label", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Task", -1)),
                                          ((_ctx.presentTaskObject?.controlMaintenanceTask))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(_ctx.presentTaskObject?.controlMaintenanceTask||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_46, "N/A"))
                                        ]),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controlsArray, (control, index) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: control.framework,
                                            class: "pt-2 pb-3"
                                          }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(control.controlsDetailsArray, (detail) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: detail.controlNumber
                                              }, [
                                                _createElementVNode("div", _hoisted_47, [
                                                  _createElementVNode("div", _hoisted_48, "Framework " + _toDisplayString(index+1) + " (" + _toDisplayString(control.framework) + ")", 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_49, [
                                                  _createElementVNode("div", _hoisted_50, [
                                                    _cache[84] || (_cache[84] = _createElementVNode("div", { class: "w-50 border-t border-l border-r border-b p-2 header border-lightgrey rounded-l-sm" }, [
                                                      _createElementVNode("label", { class: "controllabel" }, "Number")
                                                    ], -1)),
                                                    _createElementVNode("div", _hoisted_51, [
                                                      _createElementVNode("div", _hoisted_52, [
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass([_ctx.getBorder(), 'text-xs px-2 py-0.5 font-opensans bg-white font-bold h-auto flex items-center'])
                                                        }, _toDisplayString(detail.controlNumber), 3)
                                                      ])
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_53, [
                                                  _cache[85] || (_cache[85] = _createElementVNode("label", { class: "controllabel" }, "Description ", -1)),
                                                  _cache[86] || (_cache[86] = _createElementVNode("div", { class: "pl-9 pr-1 ml-1" }, ":", -1)),
                                                  (detail.description == null || detail.description == undefined)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString('N/A')))
                                                    : (_openBlock(), _createElementBlock("p", _hoisted_55, _toDisplayString(detail.description), 1))
                                                ])
                                              ]))
                                            }), 128))
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, _cache[87] || (_cache[87] = [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", { class: "border-b border-lightgrey flex justify-between pb-2 mt-3" }, [
                                            _createElementVNode("div", { class: "flex items-center mt-0.5 marginTopForDoc marginBottomForDoc justify-center" }, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("p", { class: "header" }, "Documents which are related to the controls")
                                              ])
                                            ])
                                          ])
                                        ], -1)
                                      ])))
                                    : _createCommentVNode("", true),
                                  (tab.id == 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                        _createElementVNode("div", _hoisted_58, [
                                          _cache[89] || (_cache[89] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("p", { class: "my-1.5 header" }, "Related Tasks")
                                            ])
                                          ], -1)),
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_59, [
                                              _createElementVNode("div", _hoisted_60, [
                                                _createElementVNode("button", {
                                                  class: _normalizeClass(["flex", _ctx.tableRow.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton']),
                                                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
                                                }, [
                                                  (_ctx.tableRow.length == 0)
                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_61))
                                                    : (_openBlock(), _createElementBlock("img", _hoisted_62)),
                                                  _cache[88] || (_cache[88] = _createTextVNode(" Filters "))
                                                ], 2)
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_tableData, {
                                            tableRowData: _ctx.tableRow,
                                            headersData: _ctx.Headers
                                          }, null, 8, ["tableRowData", "headersData"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_64, [
                                            _createElementVNode("div", _hoisted_65, [
                                              _createElementVNode("div", _hoisted_66, [
                                                _cache[90] || (_cache[90] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                  _createElementVNode("p", { class: "header" }, "Files")
                                                ], -1)),
                                                _createElementVNode("div", _hoisted_67, [
                                                  _createElementVNode("button", {
                                                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openLinkEvidencePopup && _ctx.openLinkEvidencePopup(...args))),
                                                    class: _normalizeClass([_ctx.isEvidenceAttachDisabled() ? 'btndisabled pointer-events-none': 'filterButton flex justify-center', "flex justify-center"])
                                                  }, "Link Existing", 2),
                                                  _createElementVNode("button", {
                                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openFilePopup('file'))),
                                                    for: "upload",
                                                    class: _normalizeClass([_ctx.TaskDetailsDropDown.taskStatus == 10401 || _ctx.TaskDetailsDropDown.taskStatus == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10417 || _ctx.TaskDetailsDropDown.taskStatus == 10418 || !_ctx.isAddDisabled(10302) ? 'btndisabled pointer-events-none': 'filterButton flex justify-center', "flex justify-center"])
                                                  }, "Attach", 2)
                                                ])
                                              ]),
                                              (_ctx.fileEvidences.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileEvidences, (doc, fileIdx) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        key: 'file-'+fileIdx
                                                      }, [
                                                        _createElementVNode("div", _hoisted_69, [
                                                          _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                            class: "flex w-full flex-row items-center cursor-pointer"
                                                          }, [
                                                            ( _ctx.getEvidenceFileExt(doc)=='pdf')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_71))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='doc')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_72))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='docx')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_73))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='xls')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_74))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='xlsx')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_75))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='rtf')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_76))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='txt')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_77))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='png')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_78))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='jpg')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_79))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='jpeg')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_80))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='csv')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_81))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='zip')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_82))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='mp4')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_83))
                                                              : _createCommentVNode("", true),
                                                            _createElementVNode("div", _hoisted_84, [
                                                              _createElementVNode("div", _hoisted_85, [
                                                                _createElementVNode("p", {
                                                                  class: "text-xs font-medium truncate",
                                                                  title: doc.filename || doc.name
                                                                }, _toDisplayString(doc.filename || doc.name || 'N/A'), 9, _hoisted_86)
                                                              ]),
                                                              _createElementVNode("div", _hoisted_87, [
                                                                _createElementVNode("p", _hoisted_88, _toDisplayString(doc.evidenceDate?_ctx.formatFileAttachedTime(doc.evidenceDate):'N/A'), 1),
                                                                _createElementVNode("p", _hoisted_89, _toDisplayString(_ctx.evidenceTaskLabel(doc)), 1)
                                                              ])
                                                            ]),
                                                            (_ctx.canDeleteAuditEvidence(doc))
                                                              ? (_openBlock(), _createElementBlock("button", {
                                                                  key: 13,
                                                                  type: "button",
                                                                  class: _normalizeClass(["evidence-file-delete", _ctx.isEvidenceAttachDisabled() ? 'pointer-events-none' : '']),
                                                                  onClick: _withModifiers(($event: any) => (_ctx.openDeleteEvidenceConfirm(_ctx.presentTaskObject.files.indexOf(doc))), ["stop","prevent"])
                                                                }, _cache[91] || (_cache[91] = [
                                                                  _createElementVNode("img", {
                                                                    src: _imports_14,
                                                                    alt: "Delete"
                                                                  }, null, -1)
                                                                ]), 10, _hoisted_90))
                                                              : _createCommentVNode("", true)
                                                          ], 8, _hoisted_70)
                                                        ])
                                                      ]))
                                                    }), 128))
                                                  ]))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_91, "No files attached"))
                                            ]),
                                            _createElementVNode("div", _hoisted_92, [
                                              _createElementVNode("div", _hoisted_93, [
                                                _cache[92] || (_cache[92] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                  _createElementVNode("p", { class: "header" }, "Links")
                                                ], -1)),
                                                _createElementVNode("div", _hoisted_94, [
                                                  _createElementVNode("button", {
                                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openFilePopup('url'))),
                                                    class: _normalizeClass([_ctx.TaskDetailsDropDown.taskStatus == 10401 || _ctx.TaskDetailsDropDown.taskStatus == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10417 || _ctx.TaskDetailsDropDown.taskStatus == 10418 || !_ctx.isAddDisabled(10302) ? 'btndisabled pointer-events-none': 'filterButton flex justify-center', "flex justify-center"])
                                                  }, "Add Link", 2)
                                                ])
                                              ]),
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["evidence-links-wrap", { 'evidence-links-wrap--empty': _ctx.filteredLinkCount === 0 }])
                                              }, [
                                                _createElementVNode("div", _hoisted_95, [
                                                  _createElementVNode("div", _hoisted_96, [
                                                    _createElementVNode("table", {
                                                      class: "evidence-links-table",
                                                      style: _normalizeStyle(_ctx.linkTableResizeStyle)
                                                    }, [
                                                      _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", null, [
                                                          _createElementVNode("th", {
                                                            class: "cursor-pointer evidence-links-col-id",
                                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortLinkEvidences('taskId')))
                                                          }, [
                                                            _createElementVNode("div", _hoisted_97, [
                                                              _cache[93] || (_cache[93] = _createElementVNode("div", null, "ID", -1)),
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'taskId' ? _ctx.linkSortClass : 'opacity-50'])
                                                              }, null, 2)
                                                            ])
                                                          ]),
                                                          _createElementVNode("th", {
                                                            class: "cursor-pointer evidence-links-col-title",
                                                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortLinkEvidences('filename')))
                                                          }, [
                                                            _createElementVNode("div", _hoisted_98, [
                                                              _cache[94] || (_cache[94] = _createElementVNode("div", null, "Link Title", -1)),
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'filename' ? _ctx.linkSortClass : 'opacity-50'])
                                                              }, null, 2)
                                                            ])
                                                          ]),
                                                          _createElementVNode("th", {
                                                            class: "cursor-pointer evidence-links-col-link",
                                                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sortLinkEvidences('url')))
                                                          }, [
                                                            _createElementVNode("div", _hoisted_99, [
                                                              _cache[95] || (_cache[95] = _createElementVNode("div", null, "Link", -1)),
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'url' ? _ctx.linkSortClass : 'opacity-50'])
                                                              }, null, 2)
                                                            ])
                                                          ]),
                                                          _createElementVNode("th", {
                                                            class: "cursor-pointer evidence-links-col-date",
                                                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sortLinkEvidences('evidenceDate')))
                                                          }, [
                                                            _createElementVNode("div", _hoisted_100, [
                                                              _cache[96] || (_cache[96] = _createElementVNode("div", null, "Evidence Date", -1)),
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'evidenceDate' ? _ctx.linkSortClass : 'opacity-50'])
                                                              }, null, 2)
                                                            ])
                                                          ]),
                                                          _cache[97] || (_cache[97] = _createElementVNode("th", { class: "evidence-links-col-action" }, null, -1))
                                                        ])
                                                      ])
                                                    ], 4)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_101, [
                                                    _createElementVNode("table", {
                                                      class: "evidence-links-table",
                                                      style: _normalizeStyle(_ctx.linkTableResizeStyle)
                                                    }, [
                                                      (_ctx.paginatedLinkEvidences.length)
                                                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_102, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedLinkEvidences, (doc, idx) => {
                                                              return (_openBlock(), _createElementBlock("tr", {
                                                                key: 'link-'+idx,
                                                                class: "rowHeight evidence-links-row"
                                                              }, [
                                                                _createElementVNode("td", {
                                                                  class: "evidence-links-col-id",
                                                                  title: _ctx.evidenceTaskLabel(doc)
                                                                }, [
                                                                  _createElementVNode("div", _hoisted_104, _toDisplayString(_ctx.evidenceTaskLabel(doc)), 1)
                                                                ], 8, _hoisted_103),
                                                                _createElementVNode("td", {
                                                                  class: "evidence-links-col-title",
                                                                  title: doc.filename || doc.name
                                                                }, [
                                                                  _createElementVNode("div", _hoisted_106, _toDisplayString(doc.filename || doc.name || 'N/A'), 1)
                                                                ], 8, _hoisted_105),
                                                                _createElementVNode("td", _hoisted_107, [
                                                                  _createElementVNode("div", _hoisted_108, [
                                                                    _createElementVNode("a", {
                                                                      href: "#",
                                                                      class: "text-primary evidence-link-anchor cursor-pointer",
                                                                      onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                                      title: doc.url
                                                                    }, _toDisplayString(doc.url), 9, _hoisted_109)
                                                                  ])
                                                                ]),
                                                                _createElementVNode("td", _hoisted_110, _toDisplayString(doc.evidenceDate ? _ctx.formatFileAttachedTime(doc.evidenceDate) : 'N/A'), 1),
                                                                _createElementVNode("td", _hoisted_111, [
                                                                  (_ctx.canDeleteAuditEvidence(doc))
                                                                    ? (_openBlock(), _createElementBlock("button", {
                                                                        key: 0,
                                                                        type: "button",
                                                                        class: _normalizeClass(["evidence-links-delete", _ctx.isEvidenceAttachDisabled() ? 'pointer-events-none' : '']),
                                                                        onClick: _withModifiers(($event: any) => (_ctx.openDeleteEvidenceConfirm(_ctx.presentTaskObject.files.indexOf(doc))), ["stop","prevent"])
                                                                      }, _cache[98] || (_cache[98] = [
                                                                        _createElementVNode("img", {
                                                                          src: _imports_14,
                                                                          alt: "Delete",
                                                                          class: "h-5 w-5"
                                                                        }, null, -1)
                                                                      ]), 10, _hoisted_112))
                                                                    : _createCommentVNode("", true)
                                                                ])
                                                              ]))
                                                            }), 128))
                                                          ]))
                                                        : (_openBlock(), _createElementBlock("tbody", _hoisted_113, _cache[99] || (_cache[99] = [
                                                            _createElementVNode("tr", null, [
                                                              _createElementVNode("td", {
                                                                class: "evidence-links-empty",
                                                                colspan: "5"
                                                              }, [
                                                                _createElementVNode("div", { class: "flex justify-center" }, [
                                                                  _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                                                                ])
                                                              ])
                                                            ], -1)
                                                          ])))
                                                    ], 4)
                                                  ])
                                                ]),
                                                (_ctx.filteredLinkCount > 0)
                                                  ? (_openBlock(), _createBlock(_component_pagination, {
                                                      key: 0,
                                                      dynamicPagination: _ctx.filteredLinkCount,
                                                      sortedData: _ctx.sortedLinkEvidences,
                                                      onCurrentPageUpdate: _ctx.onLinkPaginationUpdate
                                                    }, null, 8, ["dynamicPagination", "sortedData", "onCurrentPageUpdate"]))
                                                  : _createCommentVNode("", true)
                                              ], 2)
                                            ])
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 5)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_115, [
                                            _cache[102] || (_cache[102] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("p", { class: "header" }, "Comments")
                                              ])
                                            ], -1)),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_116, [
                                                _createElementVNode("div", _hoisted_117, [
                                                  (_ctx.oldComments)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: "filterButton w-24 flex",
                                                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortComments()))
                                                      }, _cache[100] || (_cache[100] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_15,
                                                          class: "h-3 mr-2.5"
                                                        }, null, -1),
                                                        _createTextVNode(" Oldest ")
                                                      ])))
                                                    : _createCommentVNode("", true),
                                                  (!_ctx.oldComments)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        class: "filterButton w-24 flex",
                                                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortComments()))
                                                      }, _cache[101] || (_cache[101] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_15,
                                                          class: "h-3 mr-2.5 rotate-180"
                                                        }, null, -1),
                                                        _createTextVNode(" Newest ")
                                                      ])))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_118, [
                                              (_ctx.TaskDetailsDropDown.taskStatus!=10403  && _ctx.TaskDetailsDropDown.taskStatus!=10418 && _ctx.TaskDetailsDropDown.taskStatus!=10417 && _ctx.isAddDisabled(10302))
                                                ? (_openBlock(), _createBlock(_component_commentsEditor, {
                                                    key: 0,
                                                    taskStatusCode: _ctx.TaskDetailsDropDown.taskStatus
                                                  }, null, 8, ["taskStatusCode"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            (Object.keys(_ctx.presentTaskObject).includes('comments'))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentTaskObject.comments, (obj, index) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      class: "border border-lightgrey mt-2 rounded-sm flex flex-row p-3",
                                                      key: index
                                                    }, [
                                                      _createElementVNode("div", _hoisted_120, _toDisplayString(_ctx.extractInitials((obj.name) )), 1),
                                                      _createElementVNode("div", _hoisted_121, [
                                                        _createElementVNode("div", _hoisted_122, _toDisplayString(obj.name), 1),
                                                        _createElementVNode("div", _hoisted_123, _toDisplayString(obj.createdAt), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_124, [
                                                        _createVNode(_component_safeHtml, {
                                                          content: obj.comment
                                                        }, null, 8, ["content"])
                                                      ])
                                                    ]))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 6)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_126, [
                                            _cache[103] || (_cache[103] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("p", { class: "header" }, "Findings")
                                              ])
                                            ], -1)),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_127, [
                                                _createElementVNode("button", {
                                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showFindingPopup())),
                                                  class: _normalizeClass([_ctx.isFindingEditDisabled() ? 'btndisabled pointer-events-none' : 'filterButton flex justify-center ', "w-32 flex justify-center"])
                                                }, "Add Findings", 2)
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", null, [
                                            _cache[115] || (_cache[115] = _createElementVNode("div", { class: "text-xs pt-3" }, null, -1)),
                                            (_ctx.findingsForTask.length > 0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.findingsForTask, (obj, index) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: obj._id || index,
                                                      class: _normalizeClass(["mt-4 relative", _ctx.canOpenFinding(obj) ? 'cursor-pointer' : '']),
                                                      onClick: ($event: any) => (_ctx.openExistingFinding(obj))
                                                    }, [
                                                      (!_ctx.isFindingEditDisabled())
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            type: "button",
                                                            class: "absolute top-2 right-2 z-10 p-1 rounded hover:bg-gray-100",
                                                            title: "Delete finding",
                                                            onClick: _withModifiers(($event: any) => (_ctx.openDeleteFindingConfirm(obj)), ["stop"])
                                                          }, _cache[104] || (_cache[104] = [
                                                            _createElementVNode("img", {
                                                              src: _imports_14,
                                                              class: "h-4 w-4",
                                                              alt: "Delete"
                                                            }, null, -1)
                                                          ]), 8, _hoisted_130))
                                                        : _createCommentVNode("", true),
                                                      _createElementVNode("div", _hoisted_131, [
                                                        _cache[105] || (_cache[105] = _createElementVNode("div", { class: "border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md" }, "Finding ID", -1)),
                                                        _createElementVNode("div", _hoisted_132, _toDisplayString(obj.findingId), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_133, [
                                                        _cache[106] || (_cache[106] = _createElementVNode("div", { class: "border-l w-23 border-b p-2 header border-lightgrey" }, "Framework", -1)),
                                                        _createElementVNode("div", _hoisted_134, [
                                                          _createElementVNode("div", _hoisted_135, _toDisplayString(obj.frameworks), 1)
                                                        ]),
                                                        _cache[107] || (_cache[107] = _createElementVNode("div", { class: "border-l w-23 border-b p-2 header border-lightgrey" }, "Control Number", -1)),
                                                        _createElementVNode("div", _hoisted_136, [
                                                          _createElementVNode("div", _hoisted_137, [
                                                            (obj.frameWorkControl != undefined)
                                                              ? (_openBlock(), _createElementBlock("div", {
                                                                  key: 0,
                                                                  class: _normalizeClass([_ctx.getBorder(), "text-xs px-2 py-0.5 font-opensans bg-white font-bold h-auto w-fit flex items-center"])
                                                                }, _toDisplayString(obj.frameWorkControl), 3))
                                                              : _createCommentVNode("", true)
                                                          ])
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_138, [
                                                        _cache[108] || (_cache[108] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Control Title", -1)),
                                                        _createElementVNode("div", _hoisted_139, _toDisplayString(obj.frameworkControlTitle ? obj.frameworkControlTitle : 'N/A'), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_140, [
                                                        _cache[109] || (_cache[109] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Finding", -1)),
                                                        _cache[110] || (_cache[110] = _createTextVNode()),
                                                        _createElementVNode("div", _hoisted_141, _toDisplayString(obj.findingComment), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_142, [
                                                        _cache[111] || (_cache[111] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Finding Severity", -1)),
                                                        _createElementVNode("div", _hoisted_143, [
                                                          (_ctx.getFindingSeverityValue(obj) != null)
                                                            ? (_openBlock(), _createElementBlock("div", {
                                                                key: 0,
                                                                class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular whitespace-nowrap overflow-hidden", _ctx.findingSeverityChipBg(obj)]),
                                                                title: _ctx.getFindingSeverityLabel(obj)
                                                              }, [
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["truncate whitespace-nowrap", _ctx.findingSeverityChipText(obj)])
                                                                }, _toDisplayString(_ctx.getFindingSeverityLabel(obj)), 3)
                                                              ], 10, _hoisted_144))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_145, "N/A"))
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_146, [
                                                        _cache[112] || (_cache[112] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Evidence", -1)),
                                                        _createElementVNode("div", _hoisted_147, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(obj.findingEvidence, (doc, index) => {
                                                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                                                              (obj.findingEvidence!=undefined && obj.findingEvidence.length>0)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_148, [
                                                                    _createTextVNode(_toDisplayString(_ctx.evidenceDisplayName(doc)) + " ", 1),
                                                                    (index < obj.findingEvidence.length - 1)
                                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_149, ","))
                                                                      : _createCommentVNode("", true)
                                                                  ]))
                                                                : (_openBlock(), _createElementBlock("p", _hoisted_150, "N/A"))
                                                            ]))
                                                          }), 128))
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_151, [
                                                        _cache[113] || (_cache[113] = _createElementVNode("div", { class: "border-l w-23 border-b p-2 header border-lightgrey rounded-bl-md" }, "Finding Category", -1)),
                                                        _createElementVNode("div", _hoisted_152, [
                                                          (obj.findingCategory === 1)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_153, _toDisplayString(_ctx.getCategory(obj.findingCategory)), 1))
                                                            : (obj.findingCategory === 2)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_154, _toDisplayString(_ctx.getCategory(obj.findingCategory)), 1))
                                                              : (obj.findingCategory === 3)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_155, _toDisplayString(_ctx.getCategory(obj.findingCategory)), 1))
                                                                : (obj.findingCategory === 4)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_156, _toDisplayString(_ctx.getCategory(obj.findingCategory)), 1))
                                                                  : (_openBlock(), _createElementBlock("div", _hoisted_157, "N/A"))
                                                        ]),
                                                        _cache[114] || (_cache[114] = _createElementVNode("div", { class: "border-l w-23 border-b p-2 header border-lightgrey" }, "Control Audit Result", -1)),
                                                        _createElementVNode("div", _hoisted_158, [
                                                          (obj.auditResult === 'Pass')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_159, _toDisplayString(obj.auditResult), 1))
                                                            : (obj.auditResult === 'Fail')
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_160, _toDisplayString(obj.auditResult), 1))
                                                              : (_openBlock(), _createElementBlock("div", _hoisted_161, "N/A"))
                                                        ])
                                                      ])
                                                    ], 10, _hoisted_129))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 7)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_163, [
                                            _cache[118] || (_cache[118] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("p", { class: "header" }, "History")
                                              ])
                                            ], -1)),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_164, [
                                                _createElementVNode("div", _hoisted_165, [
                                                  (_ctx.newHistory)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: "filterButton w-24 flex",
                                                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sortWorkLog()))
                                                      }, _cache[116] || (_cache[116] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_15,
                                                          class: "h-3 mr-2.5"
                                                        }, null, -1),
                                                        _createTextVNode(" Oldest ")
                                                      ])))
                                                    : _createCommentVNode("", true),
                                                  (!_ctx.newHistory)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        class: "filterButton w-24 flex",
                                                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sortWorkLog()))
                                                      }, _cache[117] || (_cache[117] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_15,
                                                          class: "h-3 mr-2.5 rotate-180"
                                                        }, null, -1),
                                                        _createTextVNode(" Newest ")
                                                      ])))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workLogObject.taskHistory, (work) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: work,
                                              class: "bg-white py-4 mb-0.5 border-lightgrey border-b w-full"
                                            }, [
                                              _createElementVNode("div", _hoisted_166, [
                                                (Object.keys(work).includes('createdBy'))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_167, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                                  : _createCommentVNode("", true),
                                                (Object.keys(work).includes('updatedBy'))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_168, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_169, [
                                                  _createElementVNode("div", _hoisted_170, [
                                                    (Object.keys(work).includes('createdBy'))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_171, _toDisplayString(work.name), 1))
                                                      : (Object.keys(work).includes('updatedBy'))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_172, _toDisplayString(work.name), 1))
                                                        : _createCommentVNode("", true),
                                                    (work.actionEntity == 10301)
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_173, _toDisplayString('Created the Task on')))
                                                      : (work.statusCode != undefined && work.statusCode == 10418)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_174, _toDisplayString('Terminated the Task on')))
                                                        : (work.actionEntity == 10302 && !Object.keys(work.additionalInfo).includes('previousDueDate'))
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_175, _toDisplayString('Updated the Task on')))
                                                          : (work.actionEntity == 10302 && Object.keys(work.additionalInfo).includes('previousDueDate'))
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_176, _toDisplayString('Updated the Due Date at')))
                                                            : _createCommentVNode("", true),
                                                    (Object.keys(work).includes('createdAt'))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_177, _toDisplayString(_ctx.formatTime(work.createdAt)), 1))
                                                      : _createCommentVNode("", true),
                                                    (Object.keys(work).includes('updatedAt'))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_178, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  (Object.keys(work).includes('additionalInfo'))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                                                        (Object.keys(work.additionalInfo).includes('comment'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                                                              _cache[119] || (_cache[119] = _createElementVNode("p", { class: "font-semibold text-xs widthForCommentBox" }, _toDisplayString('Comment :'), -1)),
                                                              _createElementVNode("p", _hoisted_181, [
                                                                _createVNode(_component_safeHtml, {
                                                                  content: work.additionalInfo.comment
                                                                }, null, 8, ["content"])
                                                              ])
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('findingId'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                                                              _cache[120] || (_cache[120] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Added the finding -'), -1)),
                                                              _createElementVNode("p", _hoisted_183, _toDisplayString(work.additionalInfo.findingId), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('updatedFindingId'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                                                              _cache[121] || (_cache[121] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Updated the finding -'), -1)),
                                                              _createElementVNode("p", _hoisted_185, _toDisplayString(work.additionalInfo.updatedFindingId), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('deletedFindingId'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                                                              _cache[122] || (_cache[122] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Removed the finding -'), -1)),
                                                              _createElementVNode("p", _hoisted_187, _toDisplayString(work.additionalInfo.deletedFindingId), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((work.additionalInfo.addedAttachments || []), (file) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            class: "flex mt-2",
                                                            key: 'added-' + file
                                                          }, [
                                                            _cache[123] || (_cache[123] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Attached -'), -1)),
                                                            _createElementVNode("p", _hoisted_188, _toDisplayString(file), 1)
                                                          ]))
                                                        }), 128)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((work.additionalInfo.removedAttachments || []), (file) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            class: "flex mt-2",
                                                            key: 'removed-' + file
                                                          }, [
                                                            _cache[124] || (_cache[124] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Removed the attachment -'), -1)),
                                                            _createElementVNode("p", _hoisted_189, _toDisplayString(file), 1)
                                                          ]))
                                                        }), 128)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((work.additionalInfo.changes || []), (change) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            class: "flex items-center mt-2",
                                                            key: change.field
                                                          }, [
                                                            _createElementVNode("p", _hoisted_190, _toDisplayString(change.field), 1),
                                                            (change.field === 'Finding Severity')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["mx-2 flex items-center justify-center rounded h-5 w-28 px-2.5 regular overflow-hidden", _ctx.findingSeverityChipBg({ findingSeverity: change.previous })]),
                                                                    title: _ctx.getFindingSeverityHistoryLabel(change.previous)
                                                                  }, [
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(["truncate whitespace-nowrap", _ctx.findingSeverityChipText({ findingSeverity: change.previous })])
                                                                    }, _toDisplayString(_ctx.getFindingSeverityHistoryLabel(change.previous)), 3)
                                                                  ], 10, _hoisted_191),
                                                                  _cache[125] || (_cache[125] = _createElementVNode("div", { class: "mx-2 flex items-center shrink-0" }, [
                                                                    _createElementVNode("img", {
                                                                      src: _imports_16,
                                                                      class: "shrink-0"
                                                                    })
                                                                  ], -1)),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular overflow-hidden", _ctx.findingSeverityChipBg({ findingSeverity: change.updated })]),
                                                                    title: _ctx.getFindingSeverityHistoryLabel(change.updated)
                                                                  }, [
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(["truncate whitespace-nowrap", _ctx.findingSeverityChipText({ findingSeverity: change.updated })])
                                                                    }, _toDisplayString(_ctx.getFindingSeverityHistoryLabel(change.updated)), 3)
                                                                  ], 10, _hoisted_192)
                                                                ], 64))
                                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                  _createElementVNode("p", _hoisted_193, _toDisplayString(change.previous || 'N/A'), 1),
                                                                  _cache[126] || (_cache[126] = _createElementVNode("div", { class: "mx-2 flex items-center" }, [
                                                                    _createElementVNode("img", { src: _imports_16 })
                                                                  ], -1)),
                                                                  _createElementVNode("p", _hoisted_194, _toDisplayString(change.updated || 'N/A'), 1)
                                                                ], 64))
                                                          ]))
                                                        }), 128)),
                                                        (Object.keys(work.additionalInfo).includes('evidence') && !work.additionalInfo.removed)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
                                                              _cache[127] || (_cache[127] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Uploaded the Evidence -'), -1)),
                                                              _createElementVNode("p", _hoisted_196, _toDisplayString(work.additionalInfo.evidence), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (work.additionalInfo.removed)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                                                              _cache[128] || (_cache[128] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Deleted the Evidence -'), -1)),
                                                              _createElementVNode("p", _hoisted_198, _toDisplayString(work.additionalInfo.evidence), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('linkedEvidenceTitles'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
                                                              _cache[129] || (_cache[129] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Linked the Evidence -'), -1)),
                                                              _createElementVNode("p", _hoisted_200, _toDisplayString(work.additionalInfo.linkedEvidenceTitles), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('linkedEvidenceDates'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_201, [
                                                              _cache[130] || (_cache[130] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Linked Evidence Date -'), -1)),
                                                              _createElementVNode("p", _hoisted_202, _toDisplayString(work.additionalInfo.linkedEvidenceDates), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('evidenceDate'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                                                              _cache[131] || (_cache[131] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Evidence Date -'), -1)),
                                                              _createElementVNode("p", _hoisted_204, _toDisplayString(_ctx.formatDate(work.additionalInfo.evidenceDate)||'N/A'), 1),
                                                              _cache[132] || (_cache[132] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('to'), -1))
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('evidenceDate'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                                                              _createElementVNode("p", _hoisted_206, _toDisplayString(_ctx.formatDate(work.additionalInfo.evidenceDate)||'N/A'), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('previousDueDate'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_207, [
                                                              _cache[133] || (_cache[133] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('from '), -1)),
                                                              _createElementVNode("p", _hoisted_208, _toDisplayString(_ctx.formatDate(work.additionalInfo.previousDueDate)||'N/A'), 1),
                                                              _cache[134] || (_cache[134] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('to'), -1)),
                                                              _createElementVNode("p", _hoisted_209, _toDisplayString(_ctx.formatDate(work.additionalInfo.updatedDueDate)||'N/A'), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('assignee'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                                                              _cache[135] || (_cache[135] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Assigned the Task To -'), -1)),
                                                              _createElementVNode("p", _hoisted_211, _toDisplayString(_ctx.getPersonName(work.additionalInfo.assignee)), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('previousStatus'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_212, [
                                                              _cache[137] || (_cache[137] = _createElementVNode("div", null, [
                                                                _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Updated The Status :'))
                                                              ], -1)),
                                                              _createElementVNode("div", _hoisted_213, [
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorAuditBg(work.additionalInfo.previousStatus)])
                                                                }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(_ctx.colorAuditText(work.additionalInfo.previousStatus))
                                                                  }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.previousStatus)), 3)
                                                                ], 2),
                                                                _cache[136] || (_cache[136] = _createElementVNode("div", { class: "mx-4 flex items-center" }, [
                                                                  _createElementVNode("img", { src: _imports_16 })
                                                                ], -1)),
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorAuditBg(work.additionalInfo.updatedStatus)])
                                                                }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(_ctx.colorAuditText(work.additionalInfo.updatedStatus))
                                                                  }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.updatedStatus)), 3)
                                                                ], 2)
                                                              ])
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_214, [
              _createElementVNode("div", _hoisted_215, [
                _cache[154] || (_cache[154] = _createElementVNode("div", { class: "pb-2 border-b border-lightgrey" }, [
                  _createElementVNode("h1", null, "Task Details")
                ], -1)),
                (_ctx.tabDataLoading == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_216, [
                      _createElementVNode("div", _hoisted_217, [
                        _createVNode(_component_dots_loader)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_218, [
                      _createElementVNode("div", _hoisted_219, [
                        _cache[138] || (_cache[138] = _createElementVNode("label", { class: "controllabel" }, "Task Status", -1)),
                        (_ctx.TaskDetailsDropDown.taskStatus == 10418)
                          ? (_openBlock(), _createElementBlock("input", _hoisted_220))
                          : (_ctx.TaskDetailsDropDown.taskStatus == 10403)
                            ? (_openBlock(), _createElementBlock("input", _hoisted_221))
                            : (_ctx.TaskDetailsDropDown.taskStatus == 10417)
                              ? (_openBlock(), _createElementBlock("input", _hoisted_222))
                              : (_openBlock(), _createElementBlock("div", _hoisted_223, [
                                  (_openBlock(), _createBlock(_component_Select, {
                                    key: _ctx.statusSelectKey,
                                    modelValue: _ctx.TaskDetailsDropDown.taskStatus,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.TaskDetailsDropDown.taskStatus) = $event)),
                                    options: _ctx.filteredTaskStatusData,
                                    disabled: _ctx.TaskDetailsDropDown.taskStatus == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10417 || _ctx.presentAuditObject.statusCode == 10403|| _ctx.presentAuditObject.statusCode == 10418 || _ctx.TaskDetailsDropDown.taskStatus == 10418 || !_ctx.isAddDisabled(10302),
                                    optionLabel: "status",
                                    optionValue: "id",
                                    placeholder: "Please select one",
                                    class: _normalizeClass(["w-full mt-2 custom-select cursor-pointer text-sm font-light rounded-sm border border-lightgrey my-task-status-select selectIcon accessDisabledColor", _ctx.changeBackground()]),
                                    onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus))),
                                    optionDisabled: _ctx.isOptionDisabled
                                  }, null, 8, ["modelValue", "options", "disabled", "class", "optionDisabled"]))
                                ]))
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                          _cache[139] || (_cache[139] = _createElementVNode("label", { class: "controllabel" }, "Assigned To", -1)),
                          (_ctx.TaskDetailsDropDown.taskStatus == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10417 || _ctx.presentAuditObject.statusCode == 10403|| _ctx.presentAuditObject.statusCode == 10418 || _ctx.presentTaskObject.auditor == _ctx.userInfo._id || (_ctx.presentTaskObject.auditee != _ctx.userInfo._id && _ctx.presentAssignee == _ctx.userInfo._id))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_224, _toDisplayString(_ctx.presentTaskObject.assignee != undefined ? _ctx.presentTaskObject.assignee.label : 'N/A'), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_225, [
                                _createVNode(_component_AutoComplete, {
                                  appendTo: "body",
                                  modelValue: _ctx.presentTaskObject.assignee,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.presentTaskObject.assignee) = $event)),
                                  suggestions: _ctx.userOptions,
                                  optionLabel: "label",
                                  placeholder: "Assigned-To",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
														'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
														'no-options': !_ctx.userOptions.length && _ctx.searchValue !== '',
													}]),
                                  onComplete: _ctx.asyncFind,
                                  onItemSelect: _ctx.onAssigneeSelect
                                }, null, 8, ["modelValue", "suggestions", "class", "onComplete", "onItemSelect"])
                              ]))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_226, [
                        _cache[140] || (_cache[140] = _createElementVNode("label", { class: "controllabel" }, "Due Date", -1)),
                        _cache[141] || (_cache[141] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.presentTaskObject.dueDate) = $event)),
                            class: "mt-2 w-full stylingForInputboxstylingForSelectAtPopup",
                            onFocus: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                            onkeydown: "return false",
                            placeholder: "Select Date",
                            disabled: _ctx.TaskDetailsDropDown.taskStatus ==10403||_ctx.TaskDetailsDropDown.taskStatus ==10418,
                            onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.updateTaskDueDate(6,_ctx.presentTaskObject.dueDate)))
                          }, null, 40, _hoisted_227), [
                            [_vModelText, _ctx.presentTaskObject.dueDate]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_228, [
                        _cache[142] || (_cache[142] = _createElementVNode("label", { class: "controllabel" }, "Auditor", -1)),
                        _cache[143] || (_cache[143] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentTaskObject.auditor != undefined || _ctx.presentTaskObject.auditor != null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_229, _toDisplayString(_ctx.getPerson(_ctx.presentTaskObject.auditor)), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_230, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_231, [
                        _cache[144] || (_cache[144] = _createElementVNode("label", { class: "controllabel" }, "Auditee", -1)),
                        _cache[145] || (_cache[145] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentTaskObject.auditee != undefined || _ctx.presentTaskObject.auditee != null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_232, _toDisplayString(_ctx.getPersonName(_ctx.presentTaskObject.auditee)), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_233, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_234, [
                        _cache[146] || (_cache[146] = _createElementVNode("label", { class: "controllabel" }, "Team", -1)),
                        _cache[147] || (_cache[147] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentTaskObject.department != undefined || _ctx.presentTaskObject.department != null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_235, _toDisplayString(_ctx.getTeamName(_ctx.presentTaskObject.department)), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_236, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_237, [
                        _cache[148] || (_cache[148] = _createElementVNode("label", { class: "controllabel" }, "Location", -1)),
                        _cache[149] || (_cache[149] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentTaskObject.department != undefined || _ctx.presentTaskObject.department != null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_238, _toDisplayString(_ctx.getLocationName(_ctx.presentTaskObject.department)), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_239, _toDisplayString('N/A')))
                      ]),
                      _createElementVNode("div", _hoisted_240, [
                        _cache[150] || (_cache[150] = _createElementVNode("label", { class: "controllabel" }, "Tier", -1)),
                        _cache[151] || (_cache[151] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("div", _hoisted_241, _toDisplayString(_ctx.getTierDetails(_ctx.presentTaskObject).tier), 1)
                      ]),
                      _createElementVNode("div", _hoisted_242, [
                        _cache[152] || (_cache[152] = _createElementVNode("label", { class: "controllabel" }, "Scope", -1)),
                        _cache[153] || (_cache[153] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("div", _hoisted_243, _toDisplayString(_ctx.getTierDetails(_ctx.presentTaskObject).tierInfo), 1)
                      ])
                    ]))
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.importpopUp)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.importpopUp
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_244, [
              _createElementVNode("div", _hoisted_245, [
                _createElementVNode("div", _hoisted_246, [
                  _createElementVNode("div", _hoisted_247, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.evidenceAttachMode === 'url' ? 'Attach Link' : 'Attach File'), 1),
                    _createElementVNode("button", {
                      class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onCancelIcon()))
                    }, _cache[155] || (_cache[155] = [
                      _createElementVNode("img", {
                        src: _imports_17,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))
                  ]),
                  _cache[163] || (_cache[163] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                  _createElementVNode("div", _hoisted_248, [
                    _createElementVNode("div", _hoisted_249, [
                      _createElementVNode("div", _hoisted_250, [
                        _createElementVNode("div", _hoisted_251, [
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_252, _toDisplayString(_ctx.evidenceAttachMode === 'url' ? 'Title' : 'File Name'), 1),
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass(["inputboxstyling text-xs mt-2", {'is-invalid': _ctx.v$.inputFileName.$error }]),
                              type: "text",
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.inputFileName) = $event)),
                              placeholder: _ctx.evidenceAttachMode === 'url' ? 'Evidence title' : 'Filename',
                              onInput: _cache[22] || (_cache[22] = ($event: any) => (_ctx.v$.inputFileName.$touch()))
                            }, null, 42, _hoisted_253), [
                              [
                                _vModelText,
                                _ctx.inputFileName,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.inputFileName.$error )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_254, [
                                  (_ctx.v$.inputFileName.required.$invalid )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_255, "Required"))
                                    : ((_ctx.v$.inputFileName.restrictCharacters50 && _ctx.v$.inputFileName.restrictCharacters50.$invalid) || (_ctx.v$.inputFileName.restrictCharacters60 && _ctx.v$.inputFileName.restrictCharacters60.$invalid))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_256, "Charcter Limit is exceeded"))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.evidenceAttachMode === 'file')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_257, [
                                _cache[158] || (_cache[158] = _createElementVNode("label", { class: "controllabel" }, "Attachment", -1)),
                                _createElementVNode("input", {
                                  type: "file",
                                  ref: "fileInput",
                                  class: "hidden",
                                  id: "upload",
                                  onChange: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                                }, null, 544),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["w-auto rounded-sm mt-2 p-8 flex flex-col items-center justify-center text-center transition border-2 border-dashed border-lightgrey bg-whitegrey", {
							'is-invalid': _ctx.v$.fileToUpload.$error || _ctx.pdfValidation,
							'border-primary': _ctx.isDragOver
						}]),
                                  onDragenter: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args)), ["prevent"])),
                                  onDragover: _cache[26] || (_cache[26] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args)), ["prevent"])),
                                  onDragleave: _cache[27] || (_cache[27] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args)), ["prevent"])),
                                  onDrop: _cache[28] || (_cache[28] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFileDrop && _ctx.onFileDrop(...args)), ["prevent"]))
                                }, [
                                  _cache[157] || (_cache[157] = _createElementVNode("img", {
                                    src: _imports_18,
                                    class: "h-10 w-10 mb-3",
                                    alt: "Upload file"
                                  }, null, -1)),
                                  (_ctx.fileName === '')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_258, " Drag and drop your file here "))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_259, _toDisplayString(_ctx.fileName), 1)),
                                  _createElementVNode("div", _hoisted_260, [
                                    _cache[156] || (_cache[156] = _createElementVNode("label", {
                                      for: "upload",
                                      class: "cursor-pointer"
                                    }, [
                                      _createElementVNode("span", { class: "btnprimary text-xs gap-1" }, [
                                        _createElementVNode("img", {
                                          src: _imports_19,
                                          class: "h-4 w-4",
                                          alt: ""
                                        }),
                                        _createTextVNode(" Browse ")
                                      ])
                                    ], -1)),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: _normalizeClass(["filterButton text-xs gap-1", _ctx.fileName === '' ? 'filterButtondisabled pointer-events-none' : '']),
                                      disabled: _ctx.fileName === '',
                                      onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedFile && _ctx.clearSelectedFile(...args)))
                                    }, " Cancel ", 10, _hoisted_261)
                                  ])
                                ], 34),
                                _createElementVNode("div", _hoisted_262, [
                                  (_ctx.v$.fileToUpload.$invalid && !_ctx.pdfValidation && (_ctx.v$.fileToUpload.$error || _ctx.pdfValidation))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_263, " File upload is required "))
                                    : _createCommentVNode("", true),
                                  (_ctx.pdfValidation && !_ctx.v$.fileToUpload.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_264, " This File Format is not Supported "))
                                    : _createCommentVNode("", true)
                                ]),
                                _cache[159] || (_cache[159] = _createElementVNode("div", { class: "mt-2 flex flex-col items-center" }, [
                                  _createElementVNode("p", { class: "text-xs text-placeholder" }, " Accepted Formats: PDF, JPG, PNG, ZIP, TXT, XLS, DOC, MP4 "),
                                  _createElementVNode("p", { class: "text-xs text-placeholder mt-1" }, " Maximum File Size: 50 MB ")
                                ], -1))
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.evidenceAttachMode === 'url')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_265, [
                                _cache[160] || (_cache[160] = _createElementVNode("label", { class: "controllabel" }, "URL", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  class: _normalizeClass(["inputboxstyling text-xs mt-2", {'is-invalid': _ctx.v$.evidenceUrl.$error }]),
                                  type: "url",
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.evidenceUrl) = $event)),
                                  placeholder: "URL",
                                  onInput: _cache[30] || (_cache[30] = ($event: any) => (_ctx.v$.evidenceUrl.$touch()))
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.evidenceUrl,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.evidenceUrl.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_266, [
                                      (_ctx.v$.evidenceUrl.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_267, "Required"))
                                        : (_ctx.v$.evidenceUrl.httpUrl.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_268, "URL must use http or https"))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_269, [
                            _cache[161] || (_cache[161] = _createElementVNode("label", { class: "controllabel" }, "Evidence Date", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.evidenceDate) = $event)),
                              type: "date",
                              class: _normalizeClass(["mt-2 w-full inputboxstylingForSelectAtPopup", {
								'inputboxstylingForSelectAtPopup': _ctx.evidenceDate === '',
								'stylingForInputboxstylingForSelectAtPopup': _ctx.evidenceDate !== '',
								'is-invalid':_ctx.v$.evidenceDate.$error
								}]),
                              onFocus: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                              style: {"height":"28px"},
                              onkeydown: "return false",
                              placeholder: "Select Date",
                              max: _ctx.todayDate
                            }, null, 42, _hoisted_270), [
                              [_vModelText, _ctx.evidenceDate]
                            ]),
                            (_ctx.v$.evidenceDate.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_271, [
                                  (_ctx.v$.evidenceDate.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_272, "Evidence date is required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[162] || (_cache[162] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_273, [
                      _createElementVNode("button", {
                        onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
                        class: _normalizeClass(_ctx.isEvidenceSaveDisabled ? 'btndisabled pointer-events-none ' : 'btnprimary'),
                        disabled: _ctx.clickOnButton
                      }, "Save", 10, _hoisted_274)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showPopUp)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 3,
          popUp: _ctx.showPopUp
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_275, [
              _createElementVNode("div", _hoisted_276, [
                _createElementVNode("div", _hoisted_277, [
                  _createElementVNode("div", _hoisted_278, [
                    _cache[165] || (_cache[165] = _createElementVNode("h1", null, "Findings", -1)),
                    _createElementVNode("button", {
                      class: "float-right text-3xl",
                      onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onCancelButtonAddPopUp()))
                    }, _cache[164] || (_cache[164] = [
                      _createElementVNode("img", {
                        src: _imports_17,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))
                  ]),
                  _cache[177] || (_cache[177] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                  _createElementVNode("div", _hoisted_279, [
                    _createElementVNode("div", _hoisted_280, [
                      _createElementVNode("div", _hoisted_281, [
                        _createElementVNode("div", _hoisted_282, [
                          _createElementVNode("div", _hoisted_283, [
                            _createElementVNode("div", _hoisted_284, [
                              _cache[166] || (_cache[166] = _createElementVNode("label", { class: "controllabel" }, "Finding-Id", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.findingsObject.findingId) = $event)),
                                disabled: "",
                                class: "inputboxstyling mt-2"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.findingsObject.findingId,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.findingsObject.findingId.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_285, [
                                    (_ctx.v$.findingsObject.findingId.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_286, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_287, [
                              _cache[167] || (_cache[167] = _createElementVNode("label", { class: "controllabel" }, "Finding Category", -1)),
                              _createVNode(_component_Select, {
                                appendTo: "body",
                                modelValue: _ctx.findingsObject.findingCategory,
                                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.findingsObject.findingCategory) = $event)),
                                options: _ctx.findingCategoryData,
                                optionLabel: "value",
                                optionValue: "id",
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full mt-2 custom-select cursor-pointer text-sm font-light rounded-sm border border-lightgrey", {
										'is-invalid': _ctx.v$.findingsObject.findingCategory.$error,
										'inputboxstylingForSelectAtPopup': _ctx.findingsObject.findingCategory === '',
										'stylingForInputboxstylingForSelectAtPopup': _ctx.findingsObject.findingCategory !== ''
									}]),
                                onChange: _ctx.updateAuditResult
                              }, null, 8, ["modelValue", "options", "class", "onChange"]),
                              (_ctx.v$.findingsObject.findingCategory.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_288, [
                                    (_ctx.v$.findingsObject.findingCategory.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_289, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_290, [
                            _createElementVNode("div", _hoisted_291, [
                              _cache[168] || (_cache[168] = _createElementVNode("label", { class: "controllabel" }, "Framework", -1)),
                              _createVNode(_component_Select, {
                                appendTo: "body",
                                modelValue: _ctx.findingsObject.frameworks,
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.findingsObject.frameworks) = $event)),
                                options: _ctx.auditFrameworkArray,
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full mt-2 custom-select cursor-pointer text-sm font-light rounded-sm border border-lightgrey", {
										'is-invalid': _ctx.v$.findingsObject.frameworks.$error,
										'inputboxstylingForSelectAtPopup': _ctx.findingsObject.frameworks === '',
										'stylingForInputboxstylingForSelectAtPopup': _ctx.findingsObject.frameworks !== ''
									}]),
                                onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.changeFrameWorkControlNums()))
                              }, null, 8, ["modelValue", "options", "class"]),
                              (_ctx.v$.findingsObject.frameworks.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_292, [
                                    (_ctx.v$.findingsObject.frameworks.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_293, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_294, [
                              _cache[169] || (_cache[169] = _createElementVNode("label", { class: "controllabel" }, "Control", -1)),
                              _createVNode(_component_Select, {
                                appendTo: "body",
                                modelValue: _ctx.findingsObject.frameWorkControl,
                                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.findingsObject.frameWorkControl) = $event)),
                                options: _ctx.selectedFrameworkControls,
                                optionLabel: "controlNumber",
                                optionValue: "controlNumber",
                                disabled: _ctx.findingsObject.frameworks == '',
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full mt-2 custom-select cursor-pointer text-sm font-light rounded-sm border border-lightgrey", {
										'is-invalid': _ctx.v$.findingsObject.frameWorkControl.$error,
										'inputboxstylingForSelectAtPopup': _ctx.findingsObject.frameWorkControl === '',
										'stylingForInputboxstylingForSelectAtPopup': _ctx.findingsObject.frameWorkControl !== ''
									}]),
                                onChange: _ctx.bindSelectedControlTitle
                              }, null, 8, ["modelValue", "options", "disabled", "class", "onChange"]),
                              (_ctx.v$.findingsObject.frameWorkControl.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_295, [
                                    (_ctx.v$.findingsObject.frameWorkControl.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_296, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_297, [
                            _cache[170] || (_cache[170] = _createElementVNode("label", { class: "controllabel" }, "Control Title", -1)),
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass(["inputboxstyling mt-2 disabled:bg-[#e9e9e9] disabled:text-[#a4a4a4] disabled:border-[#e9e9e9] disabled:cursor-not-allowed disabled:hover:bg-[#e9e9e9] disabled:focus:bg-[#e9e9e9]", { 'is-invalid': _ctx.v$.findingsObject.frameworkControlTitle.$error }]),
                              disabled: "",
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.findingsObject.frameworkControlTitle) = $event)),
                              type: "text",
                              placeholder: "Control Title"
                            }, null, 2), [
                              [_vModelText, _ctx.findingsObject.frameworkControlTitle]
                            ]),
                            (_ctx.v$.findingsObject.frameworkControlTitle.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_298, [
                                  (_ctx.v$.findingsObject.frameworkControlTitle.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_299, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_300, [
                            _createElementVNode("div", _hoisted_301, [
                              _cache[171] || (_cache[171] = _createElementVNode("label", { class: "controllabel" }, "Finding Severity", -1)),
                              _createVNode(_component_Select, {
                                appendTo: "body",
                                modelValue: _ctx.findingsObject.findingSeverity,
                                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.findingsObject.findingSeverity) = $event)),
                                options: _ctx.controlRiskSeverityLabelOptions,
                                optionLabel: "key",
                                optionValue: "value",
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full mt-2 custom-select cursor-pointer text-sm font-light rounded-sm border border-lightgrey", {
										'is-invalid': _ctx.v$.findingsObject.findingSeverity.$error,
										'inputboxstylingForSelectAtPopup': _ctx.findingsObject.findingSeverity === '',
										'stylingForInputboxstylingForSelectAtPopup': _ctx.findingsObject.findingSeverity !== ''
									}])
                              }, null, 8, ["modelValue", "options", "class"]),
                              (_ctx.v$.findingsObject.findingSeverity.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_302, [
                                    (_ctx.v$.findingsObject.findingSeverity.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_303, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_304, [
                            _cache[172] || (_cache[172] = _createElementVNode("label", { class: "controllabel" }, "Findings", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.findingsObject.findingComment) = $event)),
                              class: _normalizeClass(["inputboxstyling mt-2 resize-none", { 'is-invalid': _ctx.v$.findingsObject.findingComment.$error }]),
                              placeholder: "Findings",
                              rows: "3"
                            }, null, 2), [
                              [
                                _vModelText,
                                _ctx.findingsObject.findingComment,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.findingsObject.findingComment.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_305, [
                                  (_ctx.v$.findingsObject.findingComment.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_306, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_307, [
                            _cache[174] || (_cache[174] = _createElementVNode("label", { class: "controllabel" }, "Evidence", -1)),
                            _createVNode(_component_MultiSelect, {
                              modelValue: _ctx.findingsObject.findingEvidence,
                              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.findingsObject.findingEvidence) = $event)),
                              options: _ctx.evidenceArray,
                              optionLabel: "filename",
                              optionValue: "value",
                              dataKey: "value",
                              placeholder: "Evidences",
                              filter: true,
                              class: _normalizeClass(["w-full custom-multiselect userSelect mt-2 md:w-[530px] lg:w-[530px]", {'p-invalid': _ctx.v$.findingsObject.findingEvidence.$error}])
                            }, {
                              empty: _withCtx(() => _cache[173] || (_cache[173] = [
                                _createElementVNode("span", { class: "text-xs" }, "No Evidences Found", -1)
                              ])),
                              _: 1
                            }, 8, ["modelValue", "options", "class"]),
                            (_ctx.v$.findingsObject.findingEvidence.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_308, [
                                  (_ctx.v$.findingsObject.findingEvidence.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_309, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_310, [
                            _cache[175] || (_cache[175] = _createElementVNode("label", { class: "controllabel" }, "Control Audit Result", -1)),
                            _withDirectives(_createElementVNode("input", {
                              class: "inputboxstyling mt-2 cursor-pointer",
                              disabled: "",
                              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.findingsObject.auditResult) = $event)),
                              type: "text",
                              placeholder: "Result"
                            }, null, 512), [
                              [_vModelText, _ctx.findingsObject.auditResult]
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[176] || (_cache[176] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_311, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["mr-2", (JSON.stringify(_ctx.findingsObject) != JSON.stringify(_ctx.findingsObjectDummy)) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                        onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.onCancelbtn()))
                      }, "Cancel", 2),
                      (!_ctx.findingsObject._id)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass((JSON.stringify(_ctx.findingsObject) != JSON.stringify(_ctx.findingsObjectDummy)) ? 'btnprimary' : 'btndisabled pointer-events-none'),
                            disabled: _ctx.clickOnButtonForFinding,
                            onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.saveEnteredFinding()))
                          }, "Save", 10, _hoisted_312))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: _normalizeClass((JSON.stringify(_ctx.findingsObject) != JSON.stringify(_ctx.findingsObjectDummy)) ? 'btnprimary' : 'btndisabled pointer-events-none'),
                            disabled: _ctx.clickOnButtonForFinding,
                            onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.saveEnteredFinding()))
                          }, "Update", 10, _hoisted_313))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showCompleteFindingsDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_314, [
          _createElementVNode("div", {
            class: "absolute inset-0 bg-black opacity-40",
            onClick: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_ctx.cancelCompleteWithFindings && _ctx.cancelCompleteWithFindings(...args)))
          }),
          _createElementVNode("div", _hoisted_315, [
            _cache[178] || (_cache[178] = _createStaticVNode("<div class=\"flex items-start\" data-v-083a6d4d><div class=\"mr-3 h-10 w-10 rounded-full bg-[#FFE8D6] flex items-center justify-center shrink-0\" data-v-083a6d4d><img src=\"" + _imports_20 + "\" class=\"h-6 w-6\" alt=\"\" data-v-083a6d4d></div><div data-v-083a6d4d><h1 class=\"text-base font-semibold text-black\" data-v-083a6d4d>Mark task as Completed?</h1><p class=\"text-sm text-gray mt-2\" data-v-083a6d4d>Findings will no longer be editable.</p></div></div>", 1)),
            _createElementVNode("div", _hoisted_316, [
              _createElementVNode("button", {
                class: "completeFindingsCancel mr-2",
                onClick: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.cancelCompleteWithFindings && _ctx.cancelCompleteWithFindings(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                class: "btnprimary",
                onClick: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_ctx.confirmCompleteWithFindings && _ctx.confirmCompleteWithFindings(...args)))
              }, "Confirm")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteFindingConfirm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_317, [
          _createElementVNode("div", {
            class: "absolute inset-0 bg-black opacity-40",
            onClick: _cache[51] || (_cache[51] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteFinding && _ctx.cancelDeleteFinding(...args)))
          }),
          _createElementVNode("div", _hoisted_318, [
            _createElementVNode("div", _hoisted_319, [
              _cache[180] || (_cache[180] = _createElementVNode("div", { class: "mr-3 h-10 w-10 rounded-full bg-[#FFE8D6] flex items-center justify-center shrink-0" }, [
                _createElementVNode("img", {
                  src: _imports_20,
                  class: "h-6 w-6",
                  alt: ""
                })
              ], -1)),
              _createElementVNode("div", null, [
                _cache[179] || (_cache[179] = _createElementVNode("h1", { class: "text-base font-semibold text-black" }, "Delete finding?", -1)),
                _createElementVNode("p", _hoisted_320, "Finding " + _toDisplayString(_ctx.findingPendingDelete?.findingId) + " will be removed from this task.", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_321, [
              _createElementVNode("button", {
                class: "completeFindingsCancel mr-2",
                onClick: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteFinding && _ctx.cancelDeleteFinding(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                class: "btnprimary",
                onClick: _cache[53] || (_cache[53] = 
//@ts-ignore
(...args) => (_ctx.confirmDeleteFinding && _ctx.confirmDeleteFinding(...args)))
              }, "Delete")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteEvidenceConfirm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_322, [
          _createElementVNode("div", {
            class: "evidence-delete-backdrop",
            onClick: _cache[54] || (_cache[54] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteEvidence && _ctx.cancelDeleteEvidence(...args)))
          }),
          _createElementVNode("div", _hoisted_323, [
            _cache[181] || (_cache[181] = _createElementVNode("div", { class: "evidence-delete-dialog-title" }, [
              _createElementVNode("div", { class: "evidence-delete-warning" }, [
                _createElementVNode("img", {
                  src: _imports_20,
                  class: "evidence-delete-warning-icon",
                  alt: ""
                })
              ]),
              _createElementVNode("span", null, "Delete Evidence")
            ], -1)),
            _cache[182] || (_cache[182] = _createElementVNode("p", { class: "evidence-delete-dialog-message" }, "Are you sure you want to delete this evidence?", -1)),
            _createElementVNode("div", _hoisted_324, [
              _createElementVNode("button", {
                type: "button",
                class: "evidence-delete-cancel",
                onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteEvidence && _ctx.cancelDeleteEvidence(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                type: "button",
                class: "evidence-delete-ok",
                onClick: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.confirmDeleteEvidence && _ctx.confirmDeleteEvidence(...args)))
              }, "OK")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.linkEvidencePopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_325, [
          _createElementVNode("div", {
            class: "link-existing-backdrop",
            onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.closeLinkEvidencePopup && _ctx.closeLinkEvidencePopup(...args)))
          }),
          _createElementVNode("div", _hoisted_326, [
            _cache[192] || (_cache[192] = _createElementVNode("div", { class: "link-existing-title" }, [
              _createElementVNode("span", {
                class: "link-existing-warning",
                "aria-hidden": "true"
              }, [
                _createElementVNode("img", {
                  src: _imports_20,
                  class: "link-existing-warning-icon",
                  alt: ""
                })
              ]),
              _createElementVNode("span", null, "Link Existing Evidence")
            ], -1)),
            _cache[193] || (_cache[193] = _createElementVNode("p", { class: "link-existing-message" }, "Select evidence from the past year listed below.", -1)),
            _createElementVNode("div", _hoisted_327, [
              _createElementVNode("div", _hoisted_328, [
                _createElementVNode("div", _hoisted_329, "EXISTING EVIDENCE (" + _toDisplayString(_ctx.filteredSortedExistingEvidences.length) + ")", 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "filterButton flex",
                  onClick: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => (_ctx.toggleExistingEvidenceFilters && _ctx.toggleExistingEvidenceFilters(...args)))
                }, _cache[183] || (_cache[183] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "filterIcon"
                  }, null, -1),
                  _createTextVNode(" Filters ")
                ]))
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["link-existing-table-wrap", { 'link-existing-table-wrap--empty': _ctx.filteredSortedExistingEvidences.length === 0 }])
              }, [
                _createElementVNode("table", _hoisted_330, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[188] || (_cache[188] = _createElementVNode("th", { class: "link-existing-col-check" }, null, -1)),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.sortExistingEvidence('filename')))
                      }, [
                        _createElementVNode("div", _hoisted_331, [
                          _cache[184] || (_cache[184] = _createElementVNode("div", { class: "table-header-label" }, "TITLE", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'filename' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.sortExistingEvidence('sourceTaskId')))
                      }, [
                        _createElementVNode("div", _hoisted_332, [
                          _cache[185] || (_cache[185] = _createElementVNode("div", { class: "table-header-label" }, "TASK ID", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'sourceTaskId' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.sortExistingEvidence('evidenceType')))
                      }, [
                        _createElementVNode("div", _hoisted_333, [
                          _cache[186] || (_cache[186] = _createElementVNode("div", { class: "table-header-label" }, "TYPE", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'evidenceType' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.sortExistingEvidence('evidenceDate')))
                      }, [
                        _createElementVNode("div", _hoisted_334, [
                          _cache[187] || (_cache[187] = _createElementVNode("div", { class: "table-header-label" }, "EVIDENCE DATE", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'evidenceDate' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ])
                    ]),
                    (_ctx.showExistingEvidenceFilters)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_335, [
                          _cache[189] || (_cache[189] = _createElementVNode("td", { class: "link-existing-col-check" }, null, -1)),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "searchForInputBoxStyling",
                              "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.existingEvidenceFilters.filename) = $event)),
                              placeholder: "Search",
                              onClick: _cache[64] || (_cache[64] = _withModifiers(() => {}, ["stop"]))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.existingEvidenceFilters.filename,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "searchForInputBoxStyling",
                              "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.existingEvidenceFilters.sourceTaskId) = $event)),
                              placeholder: "Search",
                              onClick: _cache[66] || (_cache[66] = _withModifiers(() => {}, ["stop"]))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.existingEvidenceFilters.sourceTaskId,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "searchForInputBoxStyling",
                              "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.existingEvidenceFilters.evidenceType) = $event)),
                              placeholder: "Search",
                              onClick: _cache[68] || (_cache[68] = _withModifiers(() => {}, ["stop"]))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.existingEvidenceFilters.evidenceType,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _cache[190] || (_cache[190] = _createElementVNode("td", null, null, -1))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.filteredSortedExistingEvidences.length)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_336, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSortedExistingEvidences, (row) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: row.optionKey
                          }, [
                            _createElementVNode("td", _hoisted_337, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: _ctx.isExistingEvidenceSelected(row),
                                onChange: ($event: any) => (_ctx.toggleExistingEvidence(row))
                              }, null, 40, _hoisted_338)
                            ]),
                            _createElementVNode("td", {
                              title: row.filename
                            }, _toDisplayString(row.filename), 9, _hoisted_339),
                            _createElementVNode("td", null, _toDisplayString(row.sourceTaskId), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.existingEvidenceTypeLabel(row)), 1),
                            _createElementVNode("td", null, _toDisplayString(row.evidenceDate ? _ctx.formatFileAttachedTime(row.evidenceDate) : 'N/A'), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_340, _cache[191] || (_cache[191] = [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", {
                            class: "link-existing-empty",
                            colspan: "5"
                          }, "No Records Found")
                        ], -1)
                      ])))
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_341, [
              _createElementVNode("button", {
                type: "button",
                class: "link-existing-cancel",
                onClick: _cache[69] || (_cache[69] = 
//@ts-ignore
(...args) => (_ctx.closeLinkEvidencePopup && _ctx.closeLinkEvidencePopup(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["link-existing-save", _ctx.selectedExistingEvidences.length === 0 ? 'link-existing-save-disabled' : '']),
                onClick: _cache[70] || (_cache[70] = 
//@ts-ignore
(...args) => (_ctx.saveLinkedEvidence && _ctx.saveLinkedEvidence(...args)))
              }, "Save", 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.toolTipActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_342, [
          _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}